/**
 * Crafting recipes configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.984Z
 */

import { ConfigType } from './ConfigType';

export interface CraftConfig {
  recipe_id: string;
  input_item: string;
  input_qty: number;
  output_item: string;
  out_qty: number;
  base_time_s: number;
  station: string;
  req_tier: number;
  notes: any;
  configType: ConfigType.CRAFTS;
}

export const craftsData: Record<string, CraftConfig> = {
  bar_stone: {
    recipe_id: 'bar_stone',
    input_item: 'ore_stone',
    input_qty: 5,
    output_item: 'bar_stone',
    out_qty: 1,
    base_time_s: 0,
    station: 'Smelter',
    req_tier: 1,
    notes: 'базовый плав',
    configType: ConfigType.CRAFTS,
  },
  bar_crystal: {
    recipe_id: 'bar_crystal',
    input_item: 'ore_crystal',
    input_qty: 6,
    output_item: 'bar_crystal',
    out_qty: 1,
    base_time_s: 0,
    station: 'Smelter',
    req_tier: 1,
    notes: 'стабильно проводит ток',
    configType: ConfigType.CRAFTS,
  },
  bar_phase_mithril: {
    recipe_id: 'bar_phase_mithril',
    input_item: 'ore_mithril',
    input_qty: 1,
    output_item: 'bar_phase_mithril',
    out_qty: 1,
    base_time_s: 6.4,
    station: 'Smelter',
    req_tier: 3,
    notes: 'лёгкий сплав для дронов',
    configType: ConfigType.CRAFTS,
  },
  bar_hardlight_adamant: {
    recipe_id: 'bar_hardlight_adamant',
    input_item: 'ore_adamant',
    input_qty: 1,
    output_item: 'bar_hardlight_adamant',
    out_qty: 1,
    base_time_s: 6.6,
    station: 'Smelter',
    req_tier: 4,
    notes: '«твёрдый свет»',
    configType: ConfigType.CRAFTS,
  },
  bar_runecircuit: {
    recipe_id: 'bar_runecircuit',
    input_item: 'ore_runite',
    input_qty: 1,
    output_item: 'bar_runecircuit',
    out_qty: 1,
    base_time_s: 6.8,
    station: 'Smelter',
    req_tier: 5,
    notes: 'рунные дорожки сохраняются',
    configType: ConfigType.CRAFTS,
  },
  bar_synth_citrine: {
    recipe_id: 'bar_synth_citrine',
    input_item: 'ore_citrine',
    input_qty: 1,
    output_item: 'bar_synth_citrine',
    out_qty: 1,
    base_time_s: 7,
    station: 'Smelter',
    req_tier: 6,
    notes: 'тёплый кварц',
    configType: ConfigType.CRAFTS,
  },
  bar_night_amethyst: {
    recipe_id: 'bar_night_amethyst',
    input_item: 'ore_amethyst',
    input_qty: 1,
    output_item: 'bar_night_amethyst',
    out_qty: 1,
    base_time_s: 7.2,
    station: 'Smelter',
    req_tier: 7,
    notes: 'светочувствительный',
    configType: ConfigType.CRAFTS,
  },
  bar_overdrive_topaz: {
    recipe_id: 'bar_overdrive_topaz',
    input_item: 'ore_topaz',
    input_qty: 1,
    output_item: 'bar_overdrive_topaz',
    out_qty: 1,
    base_time_s: 7.4,
    station: 'Smelter',
    req_tier: 8,
    notes: 'даёт «овердрайв»',
    configType: ConfigType.CRAFTS,
  },
  bar_deep_obsidian: {
    recipe_id: 'bar_deep_obsidian',
    input_item: 'ore_obsidian',
    input_qty: 1,
    output_item: 'bar_deep_obsidian',
    out_qty: 1,
    base_time_s: 7.6,
    station: 'Smelter',
    req_tier: 9,
    notes: 'пьёт свет',
    configType: ConfigType.CRAFTS,
  },
  bar_demonite_ember: {
    recipe_id: 'bar_demonite_ember',
    input_item: 'ore_demonite',
    input_qty: 1,
    output_item: 'bar_demonite_ember',
    out_qty: 1,
    base_time_s: 7.8,
    station: 'Smelter',
    req_tier: 10,
    notes: ['горячий', 'нестабилен'],
    configType: ConfigType.CRAFTS,
  },
  bar_vr_tinspark: {
    recipe_id: 'bar_vr_tinspark',
    input_item: 'ore_vr_tin',
    input_qty: 1,
    output_item: 'bar_vr_tinspark',
    out_qty: 1,
    base_time_s: 8,
    station: 'Smelter',
    req_tier: 11,
    notes: 'эхо симуляции',
    configType: ConfigType.CRAFTS,
  },
  bar_vr_night_amethyst: {
    recipe_id: 'bar_vr_night_amethyst',
    input_item: 'ore_vr_amethyst',
    input_qty: 1,
    output_item: 'bar_vr_night_amethyst',
    out_qty: 1,
    base_time_s: 8.2,
    station: 'Smelter',
    req_tier: 12,
    notes: 'хранит «скриншоты» тепла',
    configType: ConfigType.CRAFTS,
  },
  bar_vr_demonite: {
    recipe_id: 'bar_vr_demonite',
    input_item: 'ore_vr_demonite',
    input_qty: 1,
    output_item: 'bar_vr_demonite',
    out_qty: 1,
    base_time_s: 8.4,
    station: 'Smelter',
    req_tier: 13,
    notes: 'спайки мощности',
    configType: ConfigType.CRAFTS,
  },
  bar_vr_error: {
    recipe_id: 'bar_vr_error',
    input_item: 'ore_vr_error',
    input_qty: 1,
    output_item: 'bar_vr_error',
    out_qty: 1,
    base_time_s: 8.6,
    station: 'Smelter',
    req_tier: 14,
    notes: ['дефектный', 'но полезный'],
    configType: ConfigType.CRAFTS,
  },
  bar_moonwire_lunarium: {
    recipe_id: 'bar_moonwire_lunarium',
    input_item: 'ore_lunarium',
    input_qty: 1,
    output_item: 'bar_moonwire_lunarium',
    out_qty: 1,
    base_time_s: 8.8,
    station: 'Smelter',
    req_tier: 15,
    notes: 'экономит энергию дронов',
    configType: ConfigType.CRAFTS,
  },
  bar_c137_geode: {
    recipe_id: 'bar_c137_geode',
    input_item: 'ore_earth_c137',
    input_qty: 1,
    output_item: 'bar_c137_geode',
    out_qty: 1,
    base_time_s: 9,
    station: 'Smelter',
    req_tier: 16,
    notes: 'ностальгия машин',
    configType: ConfigType.CRAFTS,
  },
  bar_meteor_shard: {
    recipe_id: 'bar_meteor_shard',
    input_item: 'ore_meteorite',
    input_qty: 1,
    output_item: 'bar_meteor_shard',
    out_qty: 1,
    base_time_s: 9.2,
    station: 'Smelter',
    req_tier: 17,
    notes: 'держит перегрев',
    configType: ConfigType.CRAFTS,
  },
  bar_singularity_node: {
    recipe_id: 'bar_singularity_node',
    input_item: 'ore_singularity',
    input_qty: 1,
    output_item: 'bar_singularity_node',
    out_qty: 1,
    base_time_s: 9.4,
    station: 'Smelter',
    req_tier: 18,
    notes: 'узлы тяжести',
    configType: ConfigType.CRAFTS,
  },
  bar_halium_platelet: {
    recipe_id: 'bar_halium_platelet',
    input_item: 'ore_halium',
    input_qty: 1,
    output_item: 'bar_halium_platelet',
    out_qty: 1,
    base_time_s: 9.6,
    station: 'Smelter',
    req_tier: 19,
    notes: '«холодный» урон',
    configType: ConfigType.CRAFTS,
  },
  bar_blasphemite: {
    recipe_id: 'bar_blasphemite',
    input_item: 'ore_blasphemite',
    input_qty: 1,
    output_item: 'bar_blasphemite',
    out_qty: 1,
    base_time_s: 9.8,
    station: 'Smelter',
    req_tier: 20,
    notes: 'взрывоопасен',
    configType: ConfigType.CRAFTS,
  },
  bar_angelite_prism: {
    recipe_id: 'bar_angelite_prism',
    input_item: 'ore_angelite',
    input_qty: 1,
    output_item: 'bar_angelite_prism',
    out_qty: 1,
    base_time_s: 10,
    station: 'Smelter',
    req_tier: 21,
    notes: 'кольцевой урон',
    configType: ConfigType.CRAFTS,
  },
  bar_elysium_ingotite: {
    recipe_id: 'bar_elysium_ingotite',
    input_item: 'ore_elysium',
    input_qty: 1,
    output_item: 'bar_elysium_ingotite',
    out_qty: 1,
    base_time_s: 10.2,
    station: 'Smelter',
    req_tier: 22,
    notes: '«чистый код»',
    configType: ConfigType.CRAFTS,
  },
  bar_enemite_spore: {
    recipe_id: 'bar_enemite_spore',
    input_item: 'ore_enemite',
    input_qty: 1,
    output_item: 'bar_enemite_spore',
    out_qty: 1,
    base_time_s: 10.4,
    station: 'Smelter',
    req_tier: 23,
    notes: 'повышает резисты врагов',
    configType: ConfigType.CRAFTS,
  },
  bar_beepboopium: {
    recipe_id: 'bar_beepboopium',
    input_item: 'ore_beepboopium',
    input_qty: 1,
    output_item: 'bar_beepboopium',
    out_qty: 1,
    base_time_s: 10.6,
    station: 'Smelter',
    req_tier: 24,
    notes: 'смешной дроп',
    configType: ConfigType.CRAFTS,
  },
  bar_radion73: {
    recipe_id: 'bar_radion73',
    input_item: 'ore_radion73',
    input_qty: 1,
    output_item: 'bar_radion73',
    out_qty: 1,
    base_time_s: 10.8,
    station: 'Smelter',
    req_tier: 25,
    notes: 'офлайн-энергия',
    configType: ConfigType.CRAFTS,
  },
  bar_cranium_core: {
    recipe_id: 'bar_cranium_core',
    input_item: 'ore_cranium',
    input_qty: 1,
    output_item: 'bar_cranium_core',
    out_qty: 1,
    base_time_s: 11,
    station: 'Smelter',
    req_tier: 26,
    notes: 'ускоряет анализ',
    configType: ConfigType.CRAFTS,
  },
};

/**
 * Get CraftConfig by recipe_id
 */
export function getCrafts(id: string): CraftConfig | undefined {
  return craftsData[id];
}

/**
 * Get all CraftConfig entries
 */
export function getAllCrafts(): CraftConfig[] {
  return Object.values(craftsData);
}

/**
 * Check if CraftConfig exists
 */
export function hasCrafts(id: string): boolean {
  return id in craftsData;
}
